/**
 * Whether a listing's "Project materials" link leads anywhere. The listing
 * detail carries `project_materials_count` (the project's materials agents can
 * see); an older server leaves it out, and then the link shows as it always did.
 *
 * Its own file, not lib/projectMaterials: the listing pages are in the main
 * bundle and the materials code is loaded with the Projects pages.
 */
export function hasProjectMaterials(listing) {
  if (!listing?.project_id) return false;
  const n = listing.project_materials_count;
  return n == null || Number(n) > 0;
}
